export default __webpack_public_path__ + "static/media/i_bus-low_gy.7a501a96.svg";